import { Component, Input, OnChanges } from '@angular/core'
import { ChartConfiguration } from 'chart.js'
import { SmartLink } from '../../../shared/interfaces/smart-link.interface'
import { AggregationDataset } from '../../../shared/interfaces/visualizations/aggregation-dataset.interface'
import { ColorService } from '../../../shared/services/color.service'
import { SmartLinkService } from '../../../shared/services/smart-link.service'
import { IncentiveFamily } from '../../../shared/enums/incentive.family'

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnChanges {
  @Input() dataset: AggregationDataset
  @Input() selectedFamily: IncentiveFamily = IncentiveFamily.RDTAX;

  barChartData: ChartConfiguration<'bar'>['data']
  // We use "any" instead of ChartDataset<'bar', any>[] to attach "link" to the dataset.
  datasets: any[]

  barChartOptions: any = {
    indexAxis: 'y',
    responsive: true,
    scales: {
      x: {
        title: {
          display: true,
          color: 'black'
        },
        ticks: {
          color: 'black'
        }
      },
      y: {
        grid: {
          display: false
        },
        ticks: {
          color: 'black'
        }
      }
    }
  }
  colors: string[] = ColorService.getColors()

  constructor(private smartLinkService: SmartLinkService) {}

  ngOnChanges() {
    this.barChartOptions.scales.x.title.text = this.dataset.xAxisLabel

    this.datasets = [
      {
        data: this.dataset.data.map((d) => d.count),
        backgroundColor: this.dataset.data.map((d, i) => this.colors[i]),
        borderColor: this.dataset.data.map((d, i) => this.colors[i]),
        links: this.dataset.data.map((d) => d.link)
      }
    ]

    this.barChartData = {
      labels: this.dataset.data.map((d) => d.label),
      datasets: this.datasets
    }
  }

  onChartClick(event: any) {
    const clickedElement = event.active[0]
    if (!clickedElement) {
      return
    }
    const link: SmartLink =
      this.datasets[clickedElement.datasetIndex].links[clickedElement.index]

    if (link) {
      this.smartLinkService.goToLink(link, this.selectedFamily)
    }
  }
}
